import { render, staticRenderFns } from "./PauseButton.vue?vue&type=template&id=5f904a35&"
import script from "./PauseButton.vue?vue&type=script&lang=ts&"
export * from "./PauseButton.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports